export default {
    state: {
        sort: {
            direction: '',
            field: ''
        },
        filters: [],
        list: null,
    },
    getters: {
        getListSort: function (state) {
            return state.sort;
        },

        getListFilters: function (state) {
            return state.filters;
        },

        getList: function (state) {
            return state.list;
        },
    },
    mutations: {
        setListSort: function (state, sort) {
            if (sort.direction !== undefined) {
                state.sort.direction = sort.direction;
            }
            if (sort.field !== undefined) {
                state.sort.field = sort.field;
            }
        },

        filterListBy: function (state, filter) {
            let index = state.filters.findIndex(f => f.field === filter.field);
            if (index >= 0) {
                state.filters.splice(index, 1);
            }

            state.filters.push(filter);
        },

        setListFilters: function(state, payload) {
            state.filters = payload;
        },

        setList: function(state, list) {
            state.list = list;
        }
    },
    actions: {},
    modules: {}
}
